<template>
  <div id="help-about" class="space-about">
    <VuePerfectScrollbar class="attendance-scroll-area" :settings="settings">
      <!-- <h4>{{ $t("HELP_ABOUT").Cma_Title }}</h4> -->
      <div class="content-sobre">
        <!-- <img src="../../../assets/images/logo/logo_cma.jpg" /> -->
        <div>
          <a target="_blank" @click.stop="openCmaUrl"><div class="logo-cma-help cursor-pointer" ></div></a>
          <span class="texto-cma">{{ $t("HELP_ABOUT").Cma_Text }}</span>
          <p class="mt-1"><a class="alink" target="_blank" @click.stop="openCmaUrl">{{ $t("HELP_ABOUT").Visit_Website }} {{ $t("GENERAL").Cma_Url }}</a></p>
          <!-- <span class="texto-cma">{{ $t("HELP_ABOUT").Visit_Website }} <a :href="cmaSite" target="_blank">{{cmaSite}}</a></span> -->
        </div>
      </div>

      <template v-if="isSafrasPlatform">
        <vs-divider></vs-divider>
        <!-- <h4>{{ $t("HELP_ABOUT").Safras_Title }}</h4> -->
        <div class="content-sobre">
          <!-- <img src="../../../assets/images/logo/safraslogo.png" /> -->
          <a target="_blank" @click.stop="openSafrasUrl"><div class="logo-safras-help cursor-pointer" ></div></a>
          <span class="texto-cma">{{ $t("HELP_ABOUT").Safras_Text }}</span>
          <p class="mt-1"><a class="alink" target="_blank" @click.stop="openSafrasUrl">{{ $t("HELP_ABOUT").Visit_Website }} {{ $t("GENERAL").Safras_Url }}</a></p>
          <!-- <span class="alink" @click.stop="openCmaUrl">Visite o site: www.safras.com.br</span> -->
        </div>

      </template>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import themeConfig from "../../../../themeConfig";
import AppConstants from "../../../appConstants";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import checkDeviceTypeHelper from "../../../helpers/check-device-type-helper";
import biometryHelper from "../../../helpers/biometry-helper";

export default {
  props: {},
  components: {
    VuePerfectScrollbar
  },
  data() {
    return {
      settings: {
          maxScrollbarLength: 60,
          wheelSpeed: 0.5
        },
    };
  },
  computed: {
    safrasSite() {
      return this.$t('GENERAL').Safras_Url;
    },
    cmaSite() {
      return this.$t('GENERAL').Cma_Url;
    },
    isSafrasPlatform() {
      return themeConfig.client == AppConstants.PLATFORM_CLIENT.SAFRAS;
    },
  },
  methods: {
    openSafrasUrl() {
      if (checkDeviceTypeHelper.isNativeApp()) {
        if (checkDeviceTypeHelper.isReactApp()) {
          biometryHelper.openExternalUrl(this.safrasSite);
        } else {
          cordova.InAppBrowser.open(this.safrasSite, '_system');
        }
      } else {
        window.open(this.safrasSite, '_blank');
      }
    },
    openCmaUrl() {
      if (checkDeviceTypeHelper.isNativeApp()) {
        if (checkDeviceTypeHelper.isReactApp()) {
          biometryHelper.openExternalUrl(this.cmaSite);
        } else {
          cordova.InAppBrowser.open(this.cmaSite, '_system');
        }
      } else {
        window.open(this.cmaSite, '_blank');
      }
    }
  }
};
</script>

<style lang="scss">
#help-about {
  img {
    width: 100px;
    float: left;
    margin-right: 15px;
  }
}

.content-sobre img {
  padding-left: 13px;
  padding-top: 15px;
}

.content-sobre {
  font-size: 12px;
  line-height: 20px;
  margin-top: 11px;
}
</style>
